import { RpcClient } from '../rpc-socket/rpcClient';

export namespace TableApi {
  export type TDataTableReadParams<T> = {
    tableName: string; // Название таблицы данные которой мы вычитываем
    tableCaption: string; // Заголовок таблицы (диалога)
    progress: {
      max: number; // максимальная позиция прогрессбара (минимальная 1)
      pos: number; // текущая позиция прогрессбара
      status: 'progress' | 'finish' | 'aborted'; // progress - в процессе вычитывания, finish - вычитывание завершено, aborted - вычитывание завершил пользователь
      caption: string; // какой то поясняющий заголовок, должен быть рядом с прогрессбаром
    };
    data: T;
  };

  export type TDataTableUpdIns = [number, number, number, string];
  export type TDataTableUpdRequest = {
    data: {
      table: {
        ins: Array<TDataTableUpdIns>;
      };
    };
    objectId: Array<string>;
    tableCaption: string;
    tableName: string;
  };

  export type TDataTableUpdResponse = {
    status: 'accept' | 'decline';
  };
  export const dataTableUpd = (request: TDataTableUpdRequest) => {
    return RpcClient.call(
      'dataTableUpd',
      request
    ) as Promise<TDataTableUpdResponse>;
  };

  export type TDataTableExecuteRequest = {
    tableName: 'power_profile';
    beginPeriod: number; // Unix timestamp в секундах
    endPeriod: number; // Unix timestamp в секундах
  };
  export const dataTableExecute = (request: TDataTableExecuteRequest) => {
    return RpcClient.call('dataTableExecute', request) as Promise<any>;
  };

  export type TDataTableAbort = {
    tableName: 'power_profile' | 'counter_data';
  };
  export const dataTableAbort = (request: TDataTableAbort) => {
    return RpcClient.call('dataTableAbort', request) as Promise<any>;
  };

  export type TDataTableExport = {
    tableName: string;
    format: string;
  };

  export type TDataTableExportResponse = {
    tableName: string;
    url: string;
  };

  export const dataTableExport = (request: TDataTableExport) => {
    return RpcClient.call(
      'dataTableExport',
      request
    ) as Promise<TDataTableExportResponse>;
  };
}
